// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const SdkRequestBodyType = {
    typeReference: (value) => {
        return Object.assign(Object.assign({}, value), { type: "typeReference", _visit: function (visitor) {
                return FernIr.SdkRequestBodyType._visit(this, visitor);
            } });
    },
    bytes: (value) => {
        return Object.assign(Object.assign({}, value), { type: "bytes", _visit: function (visitor) {
                return FernIr.SdkRequestBodyType._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "typeReference":
                return visitor.typeReference(value);
            case "bytes":
                return visitor.bytes(value);
            default:
                return visitor._other(value);
        }
    },
};
